import { z } from 'zod';
import { helperSchema } from '../../zodExtensions.js';
export var CustomFieldValueType;
(function (CustomFieldValueType) {
    CustomFieldValueType["Text"] = "Text";
    CustomFieldValueType["Number"] = "Number";
    CustomFieldValueType["Date"] = "Date";
    CustomFieldValueType["Select"] = "Select";
})(CustomFieldValueType || (CustomFieldValueType = {}));
export const customField = z.object({
    id: z.number(),
    displayName: z.string().max(30, {
        message: 'Name must be less than 30 characters',
    }),
    description: z.string(),
    options: helperSchema.csv.optional(),
    valueType: z.union([
        z.literal(`${CustomFieldValueType.Text}`),
        z.literal(`${CustomFieldValueType.Number}`),
        z.literal(`${CustomFieldValueType.Date}`),
        z.literal(`${CustomFieldValueType.Select}`),
    ]),
});
export const customFieldCreate = customField.omit({ id: true });
export const customFieldUpdate = customField.omit({ valueType: true });
// ------- customer ui custom field schemas -------
export const customUiCustomFieldSelect = customField
    .pick({
    id: true,
    description: true,
    displayName: true,
})
    .merge(z.object({
    required: z.boolean(),
    valueType: z.literal(`${CustomFieldValueType.Select}`),
    options: z.string().array(),
}));
export const customUiCustomField = customField
    .pick({
    id: true,
    displayName: true,
    description: true,
})
    .merge(z.object({
    required: z.boolean(),
    valueType: z.union([
        z.literal(`${CustomFieldValueType.Text}`),
        z.literal(`${CustomFieldValueType.Number}`),
        z.literal(`${CustomFieldValueType.Date}`),
    ]),
}));
export const customFieldUiCollection = z.array(z.union([customUiCustomField, customUiCustomFieldSelect]));
export const customerUiEventCollectCustomFieldsParams = z.object({
    isDefaultCommentFieldRequired: z.boolean().optional(),
    showDefaultCommentField: z.boolean(),
    isMediaUploadRequired: z.boolean(),
    mediaUploadInstructions: z.string().optional(),
    minimumMediaUploadAmount: z.number().optional(),
    customFields: customFieldUiCollection,
});
export const customerUiEventCustomField = z.object({
    type: z.literal('collectCustomFields'),
    params: customerUiEventCollectCustomFieldsParams,
});
// ---- applied custom field schemas, these represent the custom field values ----
export const appliedCustomField = customField
    .omit({ options: true })
    .merge(z.object({ value: z.string() }));
export const appliedCustomFieldCreate = appliedCustomField.pick({
    id: true,
    value: true,
});
//# sourceMappingURL=customField.js.map